export default function AustraliaInfo() {
    return (
        <>
            {/* Main Colored Section */}
            <section className="w-full bg-[#C67B3E] py-12 px-4 sm:px-6 lg:px-16">
                <div className="max-w-7xl mx-auto text-center lg:text-left">
                    
                    <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-6">
                        Best Australia Student Visa Consultant in Ahmedabad
                    </h3>

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        Are you planning to study in Australia but unsure how to fulfill all the visa requirements? 
                        Let experienced Australia Student Visa Consultants guide you through every step of the process. 
                        Students holding a valid Australian Student Visa can stay in Australia for up to five years 
                        while pursuing full-time studies at accredited institutions.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        To apply, students must obtain a Confirmation of Enrollment (CoE) or an official admission 
                        offer letter from a university or institution registered under the Commonwealth Register 
                        of Institutions and Courses for Overseas Students (CRICOS). Professional consultants 
                        ensure that all documentation, financial requirements, and eligibility criteria are 
                        accurately fulfilled to avoid unnecessary delays or visa refusals.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        With comprehensive student counseling services, Australia Student Visa Consultants assist 
                        in course selection, university applications, financial documentation, visa filing, and 
                        interview preparation. Their in-depth knowledge of Australian immigration policies and 
                        educational institutions increases your chances of successful visa approval and smooth 
                        admission into your preferred university.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        Students can submit their visa applications online through ImmiAccount provided by the 
                        Australian immigration authorities or seek professional guidance to ensure a hassle-free 
                        and accurate submission process.
                    </p>

                </div>
            </section>
        </>
    );
}